module.exports = __webpack_public_path__ + "img/CYON.f955001e.jpg";